import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { PLEDGE_FAILURE_DESCRIPTION, PLEDGE_OVERDUE_DESCRIPTION, PLEDGE_SUCCESS_DESCRIPTION } from 'sharedweb/strings/edis.strings';
import { PledgeStatusNudgeData } from 'src/app/app.interfaces';

@Component({
  selector: 'app-pledge-status-nudge',
  templateUrl: './pledge-status-nudge.component.html',
  styleUrls: ['./pledge-status-nudge.component.scss']
})
export class PledgeStatusNudgeComponent {
  PLEDGE_SUCCESS_MESSAGE = PLEDGE_SUCCESS_DESCRIPTION;
  PLEDGE_FAILURE_MESSAGE = PLEDGE_FAILURE_DESCRIPTION;
  PLEDGE_OVERDUE_MESSAGE = PLEDGE_OVERDUE_DESCRIPTION;

  constructor(
    public dialogRef: MatDialogRef<PledgeStatusNudgeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PledgeStatusNudgeData,
    private elementRef: ElementRef
  ) { 
    // Position the dialog at the bottom right
    this.dialogRef.updatePosition({ bottom: '20px', right: '20px' });
  }
  
  ngOnInit() { }

}
